"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FuseSidebarModule = /** @class */ (function () {
    function FuseSidebarModule() {
    }
    return FuseSidebarModule;
}());
exports.FuseSidebarModule = FuseSidebarModule;
